export enum EboRoles {
  None = 0,
  Manager = 1 << 1,
  BackOffice = 1 << 2,
  Payroll = 1 << 3,
  Admin = 1 << 4,
  SysAdmin = 1 << 5,
  Mechanic = 1 << 6,
  LeadDriver = 1 << 7,
  Dispatch = 1 << 8
}

export const EboRolesMapping: Record<EboRoles, string> = {
  [EboRoles.None]: 'None',
  [EboRoles.Manager]: 'Manager',
  [EboRoles.BackOffice]: 'Back Office',
  [EboRoles.Payroll]: 'Payroll',
  [EboRoles.Admin]: 'Admin',
  [EboRoles.SysAdmin]: 'Sys Admin',
  [EboRoles.Mechanic]: 'Mechanic',
  [EboRoles.LeadDriver]: 'Lead Driver',
  [EboRoles.Dispatch]: 'Dispatch'
};

export const EboRolesRefMapping: Record<EboRoles, string> = {
  [EboRoles.None]: 'None',
  [EboRoles.Manager]: 'Managers',
  [EboRoles.BackOffice]: 'Back Office Staff',
  [EboRoles.Payroll]: 'Payroll Staff',
  [EboRoles.Admin]: 'Admin Staff',
  [EboRoles.SysAdmin]: 'Sys Admin Staff',
  [EboRoles.Mechanic]: 'Mechanics',
  [EboRoles.LeadDriver]: 'Lead Drivers',
  [EboRoles.Dispatch]: 'Dispatch Staff'
};

export const ERolesFilterMapping: Record<EboRoles, string> = {
  [EboRoles.None]: 'All',
  [EboRoles.Manager]: 'Manager',
  [EboRoles.BackOffice]: 'Back Office',
  [EboRoles.Payroll]: 'Payroll',
  [EboRoles.Admin]: 'Admin',
  [EboRoles.SysAdmin]: 'Sys Admin',
  [EboRoles.Mechanic]: 'Mechanic',
  [EboRoles.LeadDriver]: 'Lead Driver',
  [EboRoles.Dispatch]: 'Dispatch'
};

// Filtered mapping for Updates form - excludes Admin and SysAdmin
export const EboRolesForUpdatesMapping: Partial<Record<EboRoles, string>> = {
  [EboRoles.Manager]: 'Manager',
  [EboRoles.BackOffice]: 'Back Office',
  [EboRoles.Payroll]: 'Payroll',
  [EboRoles.Mechanic]: 'Mechanic',
  [EboRoles.LeadDriver]: 'Lead Driver',
  [EboRoles.Dispatch]: 'Dispatch'
};

// Array of roles available for Updates (excludes Admin and SysAdmin)
export const UpdatesAvailableRoles: EboRoles[] = [
  EboRoles.Manager,
  EboRoles.BackOffice,
  EboRoles.Payroll,
  EboRoles.Mechanic,
  EboRoles.LeadDriver,
  EboRoles.Dispatch
];
